import { render, staticRenderFns } from "./TableListHistory.vue?vue&type=template&id=b31cfd18&scoped=true"
import script from "./TableListHistory.vue?vue&type=script&lang=js"
export * from "./TableListHistory.vue?vue&type=script&lang=js"
import style0 from "./TableListHistory.vue?vue&type=style&index=0&id=b31cfd18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31cfd18",
  null
  
)

export default component.exports